import React from 'react';
import NotificationContainer from '../NotificationContainer';
import StackedNotificationsContainer from '../StackedNotificationsContainer';
import { Button, Modal } from '@zillow/constellation-10';
import { IconCloseOutline } from '@zillow/constellation-icons';

interface ModalProps {
  body: React.ReactNode;
  dividers?: boolean;
  header: React.ReactNode;
  onRequestClose?: () => void;
  onOpenChange?: () => void;
  footer: React.ReactNode;
  size?: Record<string, any>;
  persona: string;
}
function PaymentsModal({
  body,
  dividers = true,
  footer,
  header,
  onOpenChange,
  onRequestClose,
  size = { base: 'fullScreen', lg: 'md' },
  persona,
}: ModalProps): JSX.Element {
  const mainContent = (bodyContent) => {
    return (
      <>
        {persona && <NotificationContainer modal persona={persona} />}
        {persona && <StackedNotificationsContainer modal persona={persona} />}
        {bodyContent}
      </>
    );
  };

  return (
    <Modal
      body={mainContent(body)}
      dividers={dividers}
      footer={footer}
      header={header}
      onOpenChange={onOpenChange}
      size={size}
      defaultOpen
      closeButton={
        onRequestClose ? (
          <Button.Icon onClick={onRequestClose} css={{ cursor: 'pointer' }}>
            <IconCloseOutline />
          </Button.Icon>
        ) : null
      }
      useDismissProps={{
        escapeKey: false,
        outsidePress: false,
      }}
    />
  );
}

export default PaymentsModal;
